import React from 'react';
import { BG_COLORS, TEAM } from '../data/schoolData';

export default function AboutPage() {
  return (
    <>
      <div className="page-hero">
        <h2>About Our School</h2>
        <p>Where every child's journey begins with love and care</p>
      </div>
      <section className="about-page-section">
        <div className="container">
          <div className="about-grid">
            <div>
              <div className="section-tag">Our Story</div>
              <h2 className="section-title">15+ Years of Nurturing Young Minds</h2>
              <p style={{color:'#555',lineHeight:'1.8',marginBottom:'16px'}}>Founded over 15 years ago, Basaveshwar Pre-Primary School has been a beacon of quality early childhood education in Belur-Chikkanasabi. Our school was established with a singular mission — to provide every child with a safe, loving, and stimulating environment where they can blossom into confident young learners.</p>
              <p style={{color:'#555',lineHeight:'1.8',marginBottom:'16px'}}>We believe that the early years are the most formative in a child's life. Our play-based curriculum is carefully designed to develop cognitive, social, emotional and physical skills, giving every child the foundation they need to succeed in school and in life.</p>
              <ul className="about-list">
                <li>Government-recognised pre-primary institution</li>
                <li>Trained and certified teaching staff</li>
                <li>Child-safe campus with CCTV monitoring</li>
                <li>Regular parent communication &amp; PTMs</li>
                <li>Festival celebrations &amp; cultural events</li>
              </ul>
            </div>
            <div className="about-img-wrap">
              <img src="https://images.unsplash.com/photo-1571210862729-78a52d3779a2?w=700" alt="School"/>
              <div className="about-badge">
                <div className="about-badge-icon">🌟</div>
                <div className="about-badge-text">Excellence Since<br/>2009</div>
              </div>
            </div>
          </div>

          <div style={{marginTop:'60px'}}>
            <div className="section-tag">Our Values</div>
            <h2 className="section-title">Vision, Mission &amp; Values</h2>
            <div className="vision-grid">
              <div className="vision-card"><div className="v-icon">🎯</div><h3>Our Vision</h3><p>To be the most trusted and nurturing pre-primary school in the region, inspiring a lifelong love of learning in every child.</p></div>
              <div className="vision-card"><div className="v-icon">🚀</div><h3>Our Mission</h3><p>To provide a holistic, play-based early education that develops every child's intellectual, social, emotional and physical potential.</p></div>
              <div className="vision-card"><div className="v-icon">💡</div><h3>Our Values</h3><p>Respect, kindness, curiosity, creativity, integrity and joy — these values guide everything we do at our school every day.</p></div>
            </div>
          </div>

          <div style={{marginTop:'60px'}}>
            <div className="section-tag">Our Team</div>
            <h2 className="section-title">Meet Our Dedicated Staff</h2>
            <div className="team-grid">
              {TEAM.map((t,i) => (
                <div className="team-card" key={i}>
                  <div className="team-avatar" style={{background: BG_COLORS[i]}}>{t.emoji}</div>
                  <div className="team-card-body">
                    <h4>{t.name}</h4>
                    <p>{t.role}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
